import "./lessons/discuss.js.coffee";
import "./lessons/discussions.js.coffee";
import "./lessons/educator_feedback.js.coffee";
import "./lessons/lessons.js.coffee";
import "./lessons/panels.js.coffee";
import "./lessons/preview.js.coffee";
import "./lessons/stats.js.coffee";
